import { apiFetchResponse } from '../lib/apiFetch';
import { LinkResult, LinkSource, LinkTarget, TargetDetail } from './linkCallerFormat';

const enc = encodeURIComponent;

/** JSON from the backend; a refusal's own message ("That lead has no quote yet…") is kept. */
async function call<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await apiFetchResponse(`caller-links${path}`, {
    ...init,
    headers: { 'Content-Type': 'application/json', ...init.headers },
  });
  const body = await res.json().catch(() => null);
  if (!res.ok) throw new Error(body?.message || `Request failed (${res.status})`);
  return body as T;
}

export type SourceRef = { leadId: string } | { communicationId: string };

const sourceQs = (s: SourceRef) =>
  'leadId' in s ? `leadId=${enc(s.leadId)}` : `communicationId=${enc(s.communicationId)}`;

export const fetchLinkSource = (s: SourceRef) => call<LinkSource>(`/source?${sourceQs(s)}`);

export const fetchLinkSuggestions = async (s: SourceRef) =>
  (await call<{ suggestions: LinkTarget[] }>(`/suggestions?${sourceQs(s)}`)).suggestions;

export const searchLinkTargets = async (q: string, excludeLeadId?: string | null) =>
  (
    await call<{ results: LinkTarget[] }>(
      `/search?q=${enc(q)}${excludeLeadId ? `&exclude=${enc(excludeLeadId)}` : ''}`,
    )
  ).results;

export const fetchLinkTarget = (t: { kind: 'funeral' | 'lead'; id: number | string }) =>
  call<TargetDetail>(`/target?${t.kind === 'funeral' ? 'funeralId' : 'leadId'}=${enc(String(t.id))}`);

export const linkCaller = (body: Record<string, unknown>) =>
  call<LinkResult>('', { method: 'POST', body: JSON.stringify(body) });

export const undoCallerLink = (linkId: string) =>
  call<{ ok: boolean; fromLeadId: string | null; warnings: string[] }>(`/${enc(linkId)}/undo`, {
    method: 'POST',
  });
